export default "/fonts/vendor/@fontsource/inter/files/inter-latin-400-normal.woff2?c96fe5ff771f9e7b53abe32b27238136";